module.exports = __webpack_public_path__ + "assets/img/5858-mc.svg";